<bento-alert [items]="alerts">
</bento-alert>

<h1 *ngIf="productInfo" data-testid="productTitle">{{productInfo.productName}} {{ 'onvio.setup.migrations.migrations' | translate }}</h1>

<!--TODO: Refactor to remove the ngSwitch as it violates dependency inversion principle and increases coupling.
  Probably by extracting them to separate components and using router-outlet-->
<ng-template ngSwitch="{{productInfo.productName}}" #inProgressEmptyState>
	<ng-template ngSwitchCase="UltraTax CS">
		<div class="d-flex flex-column align-items-center panel-border p-3 my-2">
			<h3 class="m-0 mt-1">{{'onvio.setup.migrations.ultrataxcs.startThis' | translate}}</h3>
			<span class="d-block">{{'onvio.setup.migrations.ultrataxcs.thenCome' | translate}}</span>
			<a href="{{ PREPARE_FOR_MIGRATION_LINK }}" target="_blank" rel="noopener noreferrer"
			   data-qe-id="migration-dashboard-ultratax-need-help-link"
			   class="mt-1">
				{{'onvio.setup.migrations.needHelp' | translate}}
			</a>
		</div>
	</ng-template>
	<ng-template ngSwitchCase="Practice CS">
		<div class="d-flex flex-column align-items-center panel-border p-3 my-2">
			<h3 class="m-0 mt-1">{{'onvio.setup.migrations.practicecs.startThis' | translate}}</h3>
			<span class="d-block">{{'onvio.setup.migrations.ultrataxcs.thenCome' | translate}}</span>
			<a href="{{ PREPARE_FOR_MIGRATION_LINK }}" target="_blank" rel="noopener noreferrer" class="mt-1">
				{{'onvio.setup.migrations.needHelp' | translate}}
			</a>
		</div>
	</ng-template>
	<ng-template ngSwitchCase="FileCabinet CS">
		<div class="d-flex flex-column align-items-center panel-border p-3 my-2">
			<h3 class="m-0 mt-1">{{'onvio.setup.migrations.filecabinetcs.startThis' | translate}}</h3>
			<span class="d-block">{{'onvio.setup.migrations.ultrataxcs.thenCome' | translate}}</span>
			<a href="{{ PREPARE_FOR_MIGRATION_LINK }}" target="_blank" rel="noopener noreferrer" class="mt-1">
				{{'onvio.setup.migrations.needHelp' | translate}}
			</a>
		</div>
	</ng-template>
</ng-template>

<div class="migration-status-per-product">
  <app-inprogress
    [migrationSource]="migrationSource"
	[productName]="productInfo.productName"
	[customTemplate]="productInfo ? inProgressEmptyState : null">
  </app-inprogress>

  <app-completed class="completed-container"
                 [migrationSource]="migrationSource">
  </app-completed>
</div>
